function $f9ebeef1c44a2252$export$dce0c365d72e5017(tabName) {
    return $f9ebeef1c44a2252$var$handle(tabName, "content");
}
function $f9ebeef1c44a2252$export$cb8cf52e88e23c99(tabName) {
    return $f9ebeef1c44a2252$var$handle(tabName, "example");
}
function $f9ebeef1c44a2252$var$handle(tabName, className) {
    const contentTabs = document.getElementsByClassName(className + "-tab");
    for(let i = 0; i < contentTabs.length; i++)contentTabs[i].style.display = "none";
    const tablinks = document.getElementsByClassName(className + "-lnk");
    for(let i = 0; i < tablinks.length; i++)tablinks[i].className = tablinks[i].className.replace("is-active", "");
    const activeElement = document.getElementById(tabName);
    activeElement.style.display = "block";
    const tabElement = document.getElementById(tabName + "Tab");
    tabElement.className += " is-active";
}


function $0419bcb6576894b5$export$64ddf344ab9330e3(email) {
    let ret = String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    return ret !== null;
}
function $0419bcb6576894b5$export$1cea2e25b75a88f2(email) {
    fetch("https://chat.ausdertechnik.de/hooks/5rjo387r7tdampw99iiaso7xcc", {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "text/plain"
        },
        body: JSON.stringify({
            username: "Bot",
            icon_emoji: ":mailbox_with_mail:",
            text: "Newsletter registrierung: **" + email + "**"
        })
    }).then((res)=>{
        if (res.status > 299) console.error("Registration did not succeed.");
    });
}


document.addEventListener("DOMContentLoaded", ()=>{
    // Burger Menu
    // ---------------------
    // Get all "navbar-burger" elements
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll(".navbar-burger"), 0);
    // Add a click event on each of them
    $navbarBurgers.forEach((el)=>{
        el.addEventListener("click", ()=>{
            // Get the target from the "data-target" attribute
            const target = el.dataset.target;
            const $target = document.getElementById(target);
            // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
            el.classList.toggle("is-active");
            $target.classList.toggle("is-active");
        });
    });
    // Tabbar
    // ---------------------
    const $tabElements = Array.prototype.slice.call(document.querySelectorAll(".content-lnk"), 0);
    $tabElements.forEach((el)=>{
        el.addEventListener("click", ()=>{
            const targetID = el.dataset.for;
            (0, $f9ebeef1c44a2252$export$dce0c365d72e5017)(targetID);
        });
    });
    const $exampleElements = Array.prototype.slice.call(document.querySelectorAll(".example-lnk"), 0);
    $exampleElements.forEach((el)=>{
        el.addEventListener("click", ()=>{
            const targetID = el.dataset.for;
            (0, $f9ebeef1c44a2252$export$cb8cf52e88e23c99)(targetID);
        });
    });
    // Newsletter
    const indicator = document.getElementById("newsletterEmailCorrect");
    const $emailField = document.getElementById("newsletter");
    if ($emailField) {
        $emailField.addEventListener("input", (evt)=>{
            const value = $emailField.value;
            if ((0, $0419bcb6576894b5$export$64ddf344ab9330e3)(value) === false) indicator.className = "fas fa-xmark";
            else indicator.className = "fas fa-check";
        });
        $emailField.addEventListener("blur", (evt)=>{
            const email = evt.target.value;
            if ((0, $0419bcb6576894b5$export$64ddf344ab9330e3)(email) === true) {
                (0, $0419bcb6576894b5$export$1cea2e25b75a88f2)(email);
                evt.target.value = "";
            }
        });
    }
});


//# sourceMappingURL=index.45186456.js.map
